const resetPassword = {
  path: 'resetPassword',
  component: resolve => require(['../../../pages/reset-password'], resolve)
}

export default resetPassword
